module.exports = __webpack_public_path__ + "static/media/icon-switch-pc.64f7ef52.svg";